export interface FaqInfoProps {
  question: string;
  answer: string;
  analytics: string;
}

export const faqInfo = (): FaqInfoProps[] => [
  {
    question: 'What does homeowners insurance cover?',
    answer:
      'Our homeowners insurance includes three main components: Coverage for the structure of the home you own (which includes its walls, flooring, roof, etc.), coverage for the items that you own and normally keep inside of your home, and liability coverage if you accidentally cause damage or injury to someone else.',
    analytics: 'ho_what_does_the_policy_cover',
  },
  {
    question: 'What kind of unfortunate things am I covered for?',
    answer:
      'We will cover the damage to your home and your stuff due to fire, smoke, explosion, power surge, windstorms, hail, snow pressure, collisions by vehicles, and water damage. For more details, create a free quote or check out our policy.',
    analytics: 'unfortunate',
  },
  {
    question: 'How much does homeowners insurance cost?',
    answer:
      'Homeowners insurance at Lemonade starts at 10 €/month, but varies depending  on factors including your house’s age, the cost to rebuild, building materials, as well as the coverage and add-ons you choose.',
    analytics: 'insurance_cost',
  },
  {
    question: 'What is your repair network?',
    answer:
      'If, after an incident, your home needs to be fixed up, Lemonade will provide you access to a Repair Network with a wide range of providers in France that can help repair your building parts.',
    analytics: 'repair_network',
  },
  {
    question: 'How do I receive my home insurance certificate?',
    answer:
      'You’ll receive your Lemonade home insurance certificate by email just after getting your policy, but in case of doubt and to always have it in your pocket, you can also download it again from the app!',
    analytics: 'insurance_certificate',
  },
  {
    question: 'What additional coverages can I add to my policy?',
    answer:
      'Among the additional coverages you can add are burglary and vandalism, complete theft coverage, glass breakage, school insurance, and legal protection.',
    analytics: 'additional_coverages',
  },
  {
    question: 'Are my outbuildings covered?',
    answer:
      'When you make a quote with Lemonade, our chatbot Maya will ask you for information about your home. If  you share information about  your garage, garden shed, storage unit, swimming pool, fireplace, solar panel, and veranda during the quote flow, then we’ve got you covered!',
    analytics: 'outbuildings_covered',
  },
  {
    question: 'How do I file a claim?',
    answer:
      'Just open the Lemonade app and hit the ‘Claim’ button! We’ll guide you through the process from there. Once your claim is approved, we’ll deposit your payment, minus your deductible, directly into your account.',
    analytics: 'file_claim',
  },
  {
    question: 'How can I reach you?',
    answer: `You can contact our team at any time via our app and website, or feel free to send an email to <a href="mailto:contact@lemonade.com">contact@lemonade.com</a>. Our services are open Monday to Friday from 9am to 6pm. In case of an emergency only, if you wish to contact our support services, please call our support partners on: <a href="tel:+33801840506">+33 801 840 506</a>.`,
    analytics: 'contact_us',
  },
];
